<template>
    <v-row>
        <v-col cols="12">
            <p>
                <strong>
                    Unser Entschädigungs-Manager wurde sorgfältig erstellt und überprüft.
                    Er ersetzt allerdings keine Rechtsberatung und bietet keine rechtliche Gewähr dafür,
                    dass Entschädigungs-Ansprüche bestehen.
                    Bitte beachte, dass Du mit unserem Entschädigungs-Manager nur Ansprüche gegen die Fluggesellschaft
                    auf die pauschale Entschädigungszahlung nach Art. 7 der EU Fluggastrechteverordnung geltend machen
                    kannst.
                </strong>
                <a @click="toggleShowInfo">
                    Mehr dazu
                    <i v-if="viewData.showInfo" class="mdi mdi-chevron-up" aria-hidden="true"></i>
                    <i v-else class="mdi mdi-chevron-down" aria-hidden="true"></i>
                </a>
            </p>
            <p v-if="viewData.showInfo">
                Eventuelle weitere Ansprüche gegen die Fluggesellschaft, etwa Ausgaben in der Wartezeit auf den Flug,
                insbesondere Zusatzkosten für eine Unterkunft bis zur Weiterbeförderung,
                Transportkosten zu dieser Unterkunft und Verpflegungskosten,
                oder Ansprüche im Zusammenhang mit Kofferverspätungen, -verlusten oder -beschädigungen,
                wegen Verspätungen nicht nutzbare Mietwagen oder Hotelzimmer etc.,
                können mithilfe des Entschädigungs-Manager nicht geltend gemacht werden.
                Auch Ansprüche, die nicht gegen die Fluggesellschaft gerichtet sind,
                können mithilfe des Entschädigungs-Manager nicht eingefordert werden;
                dazu zählen insbesondere Minderungs- oder Schadensersatzansprüche gegen Reiseunternehmen.
                Diese Ansprüche musst Du ggf. gesondert geltend machen.
                Bitte beachte hierbei, dass Reisemängel unverzüglich gegenüber dem Reiseveranstalter anzuzeigen sind.
                Ansprüche wegen Kofferbeschädigungen sind ebenfalls unverzüglich, spätestens binnen 7 Tagen,
                Ansprüche wegen Kofferverspätungen binnen 21 Tage nach Rückkehr des Gepäcks gegenüber der Fluggesellschaft geltend zu machen.
            </p>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "DisclaimerRow",
    data: () => ({
        viewData: {
            showInfo: false
        }
    }),
    methods: {
        toggleShowInfo()
        {
            this.viewData.showInfo = !this.viewData.showInfo;
        }
    }
}
</script>

<style scoped>

</style>
